module.exports = __webpack_public_path__ + "img/login_logo.355c45e6.png";